export const server ='https://nilmrc-backend-beta.vercel.app/api/v2'